import { useEffect, useState } from 'react';
import ManageTagModalStore from 'store/modules/proposal/ui/manageTagModalStore';
import ProposalPageStore from 'store/pages/proposal/pageStore';
import { useCartItemDelegate } from 'store/pages/proposal/cartItemContext';
import { useRootStore } from 'store/rootStore';
import { autorun } from 'mobx';

export default function useManageTagModalStore(): ManageTagModalStore<ProposalPageStore> {
  const { proposalPageStore } = useRootStore();
  const cartItemDelegate = useCartItemDelegate();

  const [store, setStore] = useState(() => new ManageTagModalStore({ pageStore: proposalPageStore, cartItemDelegate }));

  useEffect(() => {
    const disposer = autorun(() => {
      setStore(new ManageTagModalStore({ pageStore: proposalPageStore, cartItemDelegate }));
    });
    return (): void => disposer();
  }, [cartItemDelegate]);

  return store;
}
